import React, { useState } from 'react'
import ManagerPostWeb from '../components/ManagerPostWeb/ManagerPostWeb'

const ManagerPostWebPage = () => {
  return (
    <>
      <ManagerPostWeb />
    </>
  )
}

export default ManagerPostWebPage
